import React from 'react'
import Resx from '@/components/Resx'
import { Input } from 'reactstrap'
import { InfoRow, InfoLabel, InfoContent } from '@/components/InfoRow'
import cached from '@/internal-app/cached'
import { DropDownList } from '@/components/dropDownList'
import { localized } from '@/decorators/localized'
import { Validator } from '@/components/validation'
import Name from '@/components/Name'
import Icon from '@/components/Icon'
import { Link } from 'react-router-dom'
import CheckBox from '@/components/CheckBox'
import { useRfc13MessagesModule } from '@/hooks/useFeatureFlags'

let OrganizationalUnitForm = (props) => {
  const { unit, units, availableParents, parent, onChange } = props
  const isRfc13MessagesModuleEnabled = useRfc13MessagesModule()

  function uniqueCode ({ value }) {
    return units.find(x => x.id !== unit.id && x.code.toLowerCase() === value.toLowerCase()) && 'OrganizationalUnit.UniqueCodeRequired'
  }

  function onParentChange ({ item }) {
    onChange({ organizationUnitParentId: item.organizationUnitId, parent: item.id })
  }

  return (
    <React.Fragment>
      <DropDownRow
        {...props}
        label='OrganizationalUnit.SuperiorOrganizationalUnitName'
        name='parent'
        data={availableParents}
        valueField='id'
        renderView={parent => <Link to={`/organizational-units/${parent.id}`}><Name data={parent} />&nbsp;<Icon name='link' /></Link>}
        onChange={onParentChange}
        {...(parent && typeof parent === 'object' ? { readonly: true, value: parent, renderView: null } : {})}
      />
      <DropDownRow
        {...props}
        label='OrganizationalUnit.Type'
        name='unitType'
        required
        dataSource={cached.getOrganizationalUnitType}
        clientSide
        isCodeList
        onChange={({ value }) => onChange({ unitType: { id: value } })}
      />
      <StringRow name='code' label='OrganizationalUnit.Code' required
        onValidate={uniqueCode} {...props} />
      <StringRow name='reference' label='OrganizationalUnit.Reference' required {...props} />
      <StringRow name='name' label='OrganizationalUnit.Name' required {...props} />
      <StringRow name='latinName' label='OrganizationalUnit.LatinName' required {...props} />
      {isRfc13MessagesModuleEnabled && (
        <React.Fragment>
          <BooleanRow name='hasActiveInbox' label='OrganizationalUnit.HasActiveInbox' {...props} />
          <BooleanRow name='visibleAsRecipientInExternal' label='OrganizationalUnit.VisibleAsRecipientInExternal' {...props} />
        </React.Fragment>
      )}
    </React.Fragment>
  )
}

function BooleanRow ({ unit, onChange, name, label, readonly }) {
  return (
    <InfoRow>
      <InfoLabel>&nbsp;</InfoLabel>
      <InfoContent>
        <CheckBox
          title={label}
          checked={unit[name] === true}
          disabled={readonly === true}
          onChange={checked => onChange({ [name]: checked })} />
      </InfoContent>
    </InfoRow>
  )
}

function StringRow ({ unit, onChange, name, label, required, readonly, onValidate }) {
  return (
    <InfoRow>
      <InfoLabel><Resx name={label} /></InfoLabel>
      <InfoContent>
        {readonly
          ? (
            unit[name]
          )
          : (
            <Validator name={name} value={unit[name]} required={required} onValidate={onValidate}>
              <Input value={unit[name] || ''} onChange={e => onChange({ [name]: e.target.value })} />
            </Validator>
          )
        }
      </InfoContent>
    </InfoRow>
  )
}

function DropDownRow ({ unit, data, dataSource, onChange, name, label, required, readonly, valueField, disabled, locale, renderView, clientSide, isCodeList }) {
  const value = unit[name] || null
  return (
    <InfoRow>
      <InfoLabel><Resx name={label} /></InfoLabel>
      <InfoContent>
        {readonly
          ? (
            value ? (typeof renderView === 'function' ? renderView(value) : <Name data={value} />) : '-'
          ) : (
            <Validator name={name} value={value} required={required}>
              {typeof dataSource === 'function'
                ? (
                  <DropDownList
                    dataSource={dataSource}
                    disabled={disabled || false}
                    onChange={onChange}
                    value={value && typeof value === 'object' ? value.id : value}
                    clientSide={clientSide}
                    isCodeList={isCodeList} />
                ) : (
                  <DropDownList
                    data={data || []}
                    textField={locale === 'en' ? 'latinName' : 'name'}
                    valueField={valueField || 'id'}
                    disabled={disabled || false}
                    onChange={onChange}
                    value={value != null && typeof value === 'object' ? value[valueField] : value} />
                )
              }
            </Validator>
          )
        }
      </InfoContent>
    </InfoRow>
  )
}

OrganizationalUnitForm = localized()(OrganizationalUnitForm)

export default OrganizationalUnitForm



// WEBPACK FOOTER //
// ./src/internal-app/pages/organizationalUnits/form.js